module.exports = __webpack_public_path__ + "static/img/company1.2a87952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company1.png
// module id = gSoa
// module chunks = 1